module.exports = function array() {
  return Array.from(arguments).slice(0, arguments.length - 1);
}
